import { Component } from '@angular/core';

@Component({
	selector: 'vcm-recovery-password-comp',
	template: require('./recovery-password.component.html')
})

export class RecoveryPasswordComponent {
}
